import { createSlice } from "@reduxjs/toolkit";
import { ROLES } from "src/constants";
import { apiCallStarted } from "../middleware/api";

const slice = createSlice({
  name: "submerchants",
  initialState: {
    list: [],
    submerchantDetails: {},
    loading: false,
    lastFetch: null,
    rowCount: 0,
    pageSize: 0,
    page: 0
  },
  reducers: {
    submerchantsRequested: (submerchants, action) => {
      submerchants.loading = true;
    },
    submerchantsRequestSucceded: (submerchants, action) => {
      const { docs, totalDocs, limit, page } = action.payload.body;
      if (page && page > submerchants.page) {
        submerchants.list = [...submerchants.list, ...docs];
        submerchants.page = page;
        submerchants.rowCount = totalDocs;
        submerchants.pageSize = limit;
      }
      submerchants.loading = false;
      submerchants.lastFetch = Date.now();
    },
    submerchantsRequestFailed: (submerchants, _) => {
      submerchants.loading = false;
    },
    submerchantDetailsRequestSucceded: (submerchants, action) => {
      submerchants.submerchantDetails = action.payload.body;
    },
    submerchantAdded: (submerchants, action) => {
      submerchants.list.push(action.payload);
    },
    submerchantRemoved: (submerchants, action) => {
      const index = submerchants.list.findIndex(
        (submerchant) => submerchant.id === action.payload.id
      );
      submerchants.list.splice(index, 1);
    },
    pageChanged: (submerchants, action) => {
      const { page: targetPage } = action.payload;
      submerchants.page = targetPage;
    },
    clearSubmerchants: (submerchants, action) => {
      submerchants.list = [];
      submerchants.page = 0;
      submerchants.rowCount = 0;
      submerchants.pageSize = 0;
      submerchants.lastFetch = null;
      submerchants.loading = false;
    },
    clearSubmerchantDetails: (submerchants, action) => {
      submerchants.submerchantDetails = {};
    }
  },
});

export const {
  submerchantsRequested,
  submerchantsRequestSucceded,
  submerchantsRequestFailed,
  submerchantDetailsRequestSucceded,
  submerchantAdded,
  submerchantRemoved,
  pageChanged,
  clearSubmerchants,
  clearSubmerchantDetails
} = slice.actions;

// Action Creators
const apiEndpoints = {
  [ROLES.admin]: "/v1/admin-panel/sub-merchants",
  [ROLES.merchant]: "/v1/merchant-dashboard/sub-merchants",
  [ROLES.shippingCompany]: "/v1/merchant-dashboard/sub-merchants"
}

export const loadSubmerchants = (role, page) => (dispatch, getState) => {
  dispatch(
    apiCallStarted({
      url: `${apiEndpoints[role]}?page=${page}`,
      onStart: submerchantsRequested.type,
      onSuccess: submerchantsRequestSucceded.type,
      onError: submerchantsRequestFailed.type,
    })
  );
};

export const loadSubmerchantDetails = (role, id) => (dispatch, getState) => {
  dispatch(
    apiCallStarted({
      url: `${apiEndpoints[role]}/${id}`,
      // onStart: submerchantsRequested.type,
      onSuccess: submerchantDetailsRequestSucceded.type,
      // onError: submerchantsRequestFailed.type,
    })
  );
};

export default slice.reducer;
